import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const bonuses = [{
  emoji: '📊',
  image: 'https://cdn.magicpatterns.com/uploads/ucEmKcoUYqfA2AHTmdqF2L/Screenshot_2026-06-13_at_8.33.54_PM.png',
  title: 'Bono 1 — Planillas Excel (Planillas_Enfermeria.xlsx)',
  subtitle: '10 pestañas con fórmulas automáticas',
  items: ['Control de signos vitales por turno', 'Balance hídrico 24h con totales automáticos y balance neto', 'Kardex de administración de medicamentos', 'Riesgo de caídas (Morse) con interpretación y colores', 'Riesgo de UPP (Braden) con plan de cuidados por nivel', 'Escalas de dolor (EVA visual + FLACC para no verbales)', 'Informe de turno SBAR estructurado', 'Registro de evento adverso / error de medicación', 'Checklist de egreso del paciente', 'Calculadora de goteo + tabla rápida + dosis por peso']
}, {
  emoji: '📝',
  image: 'https://cdn.magicpatterns.com/uploads/tp32P5ScHochb913fPyszE/Screenshot_2026-06-13_at_8.27.27_PM.png',
  title: 'Bono 2 — Apéndices Word (Apendices_Enfermeria.docx)',
  subtitle: '6 apéndices de consulta rápida',
  items: ['A — Laboratorio de referencia con valores de alerta en rojo', 'B — Abreviaturas de historia clínica argentina (50+)', 'C — Glosario para explicarle al familiar', 'D — Fármacos frecuentes con dosis, vía y qué vigilar', 'E — Incompatibilidades IV más importantes', 'F — Planilla de teléfonos institucionales para completar']
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-pastel-50 px-4" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <div className="inline-block bg-red-100 text-red-700 font-bold px-4 py-1.5 rounded-full text-sm mb-4 animate-pulse" data-id="element-17">
            GRATIS POR HOY
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-18">
            Llevate estos 2 bonos exclusivos
          </h2>
          <p className="text-slate-600" data-id="element-19">
            Herramientas descargables y editables que usás en cada turno.
          </p>
        </div>

        <div className="space-y-5" data-id="element-20">
          {bonuses.map((bono, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white border border-pastel-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-21">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left focus:outline-none" data-id="element-22">
                  {/* Image header with gradient overlay + title on top */}
                  <div className="relative h-40 md:h-48 w-full overflow-hidden" data-id="element-23">
                    <img src={bono.image} alt={bono.title} className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-24" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/70 to-navy-900/10" data-id="element-25"></div>
                    <div className="absolute inset-x-0 bottom-0 p-5 flex items-end justify-between gap-3" data-id="element-26">
                      <div className="flex items-center gap-3 min-w-0" data-id="element-27">
                        <span className="text-2xl leading-none drop-shadow" data-id="element-28">
                          {bono.emoji}
                        </span>
                        <span className="min-w-0" data-id="element-29">
                          <span className="block font-bold text-white text-base md:text-lg leading-tight drop-shadow" data-id="element-30">
                            {bono.title}
                          </span>
                          <span className="block text-pastel-200 text-xs md:text-sm drop-shadow" data-id="element-31">
                            {bono.subtitle}
                          </span>
                        </span>
                      </div>
                      <motion.div animate={{
                    rotate: isOpen ? 180 : 0
                  }} transition={{
                    duration: 0.2
                  }} className="text-white shrink-0 bg-white/15 backdrop-blur-sm rounded-full p-1.5" data-id="element-32">
                        <ChevronDown size={18} data-id="element-33" />
                      </motion.div>
                    </div>
                  </div>
                </button>

                <AnimatePresence data-id="element-34">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-35">
                      <div className="px-5 pb-5 pt-4" data-id="element-36">
                        <ul className="space-y-2" data-id="element-37">
                          {bono.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-600 text-sm" data-id="element-38">
                              <span className="shrink-0 mt-0.5 w-5 h-5 bg-navy-100 text-navy-800 rounded-full flex items-center justify-center text-[10px] font-bold" data-id="element-39">
                                {i + 1}
                              </span>
                              <span data-id="element-40">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}